const ignoreErrorsList: (string | RegExp)[] = ['chrome-extension://', 'moz-extension://'];

export default ignoreErrorsList;
